<template>
  <div id="app">
    <router-view />
  </div>
</template>

<style>
html,
body,
#app {
  height: 100%;
  width: 100%;
  margin: 0;
  padding: 0;
}
</style>

<script>
export default {
  mounted: function () {
    let _this = this;

    if (!this.$cookies.get("P_SID") || !this.$cookies.get("U_ID")) {
      this.$router.push("/login");
    }
  },
};
</script>

